import { Search } from "lucide-react";
import { Input } from "../../client/components/ui/input";
import useTranslation from "../../client/hooks/useTranslation";

export default function TopbarSymbolFilterWidget({
  value,
  onChange,
}: {
  value: string;
  onChange: (v: string) => void;
}) {
  const t = useTranslation();
  return (
    <div className="relative w-[160px]">
      <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-muted-foreground pointer-events-none" />
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t.journal.symbolPlaceholder}
        className="h-9 pl-8 text-sm"
      />
    </div>
  );
}
